/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';
import { LinkComponent } from '../../link/link.component';

@Component({
  selector: 'ods-dropdown-menu-link-item',
  imports: [LinkComponent, IconComponent],
  host: { role: 'listitem', class: 'block w-full bg-whitetext p-1.5' },
  template: `<ods-link [url]="url" [openInNewTab]="true">
    <div class="flex sm:min-w-80 min-w-full gap-3 px-3 py-1.5">
      <ng-content select="[icon]" />
      <div class="flex flex-col gap-1">
        @if (caption) {
          <p class="text-text text-sm font-medium">{{ caption }}</p>
        }
        <div class="flex items-center gap-2">
          <p class="text-primary text-sm font-normal">{{ text }}</p>
          <ods-icon name="open-link" [config]="{ size: 'small' }" />
          <span class="sr-only">Öffnet in einem neuen Tab</span>
        </div>
      </div>
    </div>
  </ods-link>`,
})
export class DropdownMenuLinkItemComponent {
  @Input() url: string;
  @Input() caption: string;
  @Input() text: string;
}
